import { z } from 'zod';

const pointSchema = z.object({ type: z.literal('Point'), coordinates: z.tuple([z.number(), z.number()]) });

export const rainGaugeWindowResponseSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
  field_result: z.object({ window_value: z.number(), accumulated_value: z.number() }),
  points: z
    .array(
      z.object({
        id: z.string(),
        station_id: z.string(),
        point: pointSchema.nullable(),
        forced_point: pointSchema.nullable(),
        date: z.string(),
        image: z.string().nullable(),
        scouter: z.object({ id: z.string(), name: z.string() }).nullable(),
        value: z.number()
      })
    )
    .default([]),
  stations: z
    .array(
      z.object({
        id: z.string(),
        name: z.string().nullish(),
        description: z.string(),
        station_type: z.string(),
        station_template_id: z.string(),
        point: pointSchema,
        installed_field: z.string().nullable(),
        field_ids: z.array(z.string()),
        single_use: z.boolean().nullable(),
        sampling_behavior: z.enum(['ACCUMULATIVE', 'ALWAYSRESET']).nullable(),
        installation_date: z.string(),
        uninstallation_date: z.string().nullable(),
        expiration_date: z.string().nullable(),
        last_renewal: z.string().nullable(),
        last_event_type: z.string().nullable(),
        last_event_date: z.string().nullable(),
        validity_in_days: z.number().nullable()
      })
    )
    .default([])
});

export type RainGaugeWindowResponse = z.infer<typeof rainGaugeWindowResponseSchema>;

export const rainGaugePopupSchema = z.object({
  observation: rainGaugeWindowResponseSchema.shape.points.removeDefault().element,
  title: z.string(),
  coordinates: z.tuple([z.number(), z.number()]),
  stationCoordinates: z.tuple([z.number(), z.number()]).optional(),
  accumulatedValue: z.number(),
  representedFields: z.array(z.object({ id: z.string(), name: z.string() }))
});

export type RainGaugePopupData = z.infer<typeof rainGaugePopupSchema>;
